import React, {ReactNode} from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
  height: 100%;
  display: flex;
  min-width: fit-content;
`
const L1 = styled.section`
  width: 200px;
  border-right: solid 1px ${({theme}) => theme.colors.grey6};
  margin: 0;
  padding: 0;
  display: flex;
  flex-shrink: 0;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`
export const L2 = styled(L1)``

const Main = styled.section`
  flex-grow: 1;
  min-width: 100px;
  overflow: auto;
  position: relative;
  background: ${({theme}) => theme.colors.grey2};
`

export const R1 = styled(L1)`
  width: 400px;
  border-right: none;
  border-left: solid 1px ${({theme}) => theme.colors.grey6};
`

export const PanelLayout = ({
  children,
  l1: l1,
  l2: l2,
  r1: r1
}: {
  children: ReactNode
  l1?: ReactNode
  l2?: ReactNode
  r1?: ReactNode
}) => {
  return (
    <Wrapper>
      {l1 ? <L1>{l1}</L1> : null}
      {
        l2 // should be wrapped in <L2> ( this is going to be within a Routes so we cant check for falsey on it )
      }
      <Main>{children}</Main>
      {r1}
    </Wrapper>
  )
}
